import axios, {
  AxiosInstance,
  InternalAxiosRequestConfig,
  AxiosResponse,
  AxiosError,
} from "axios";
import { config } from "./config";
import { useShowToast } from "@/hooks/useVant";
import { store } from "@/pinia/store";
import { encryApiList } from "./encryApiList";
import {
  AesDecrypt,
  ReqIv,
  getAESDecryption,
  getAESEncryption,
  isJSON,
} from "@/utils/encryptUtils";
import { utilIsAndroid, utilIsApp } from "../../utils";
import { useCallAppHandle } from "@/hooks/useBridge";

const {
  result_code,
  token_invalid_code,
  base_url,
  request_timeout,
  error_code,
} = config;
import { encryptMessage, decryptMessage } from "@/utils/aesCbcUtil";
import { tsApiBaseUrl } from "@/config";

// 创建axios实例
const service: AxiosInstance = axios.create({
  baseURL: base_url, // api 的 base_url
  timeout: request_timeout, // 请求超时时间
  withCredentials: utilIsApp()
});
// request拦截器
service.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const storeData = store();
    if (config.method === "post") {
      if (encryApiList.some((item) => item == config.url)) {
        // 加密接口对应逻辑，需要加密请求参数
        const paramss = await encryptMessage(
          JSON.stringify(config.data),
          storeData.keyInfo
          // AesDecrypt(storeData.keyStr)
        );
        config.data = {
          ReqEncyptData: paramss,
          // ReqEncyptData: getAESEncryption(
          //   JSON.stringify(config.data),
          //   AesDecrypt(storeData.keyStr)
          // ),
          ReqIv,
        };
      }
    }
    // get参数编码
    if (config.method === "get" && config.params) {
      let url = config.url as string;
      url += "?";
      const keys = Object.keys(config.params);
      for (const key of keys) {
        if (config.params[key] !== void 0 && config.params[key] !== null) {
          url += `${key}=${encodeURIComponent(config.params[key])}&`;
        }
      }
      url = url.substring(0, url.length - 1);
      config.params = {};
      config.url = url;
    }
    if (config.url.includes("training/registration/infoToPay")) {
      config.baseURL = tsApiBaseUrl
    }
    return config;
  },
  (error: AxiosError) => {
    // Do something with request error
    console.log("axios报错", error); // for debug
    Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  async (response: AxiosResponse<any>) => {
    const storeData = store();
    if (response.config.url.includes("training/registration/infoToPay")) {
      return response.data;
    }
    if (response.config.responseType === "blob") {
      // 如果是文件流，直接过
      return response;
    } else if (response.data.code === result_code) {
      // 加密接口对应逻辑，需要解密响应
      if (encryApiList.some((item) => item == response.config.url)) {
        let responseData = response.data.data;
        if (response.data.data) {
          responseData = await decryptMessage(
            responseData,
            storeData.keyInfo
            // storeData.keyStr
          );
        }
        // responseData = getAESDecryption(
        //   responseData,
        //   AesDecrypt(storeData.keyStr)
        // );

        responseData = isJSON(responseData)
          ? JSON.parse(responseData)
          : responseData;
        response.data.data = responseData;
      }

      console.log("响应数据为:", response);
      return response.data;
    } else {
      console.log("code500", response);
      if (response.data.code === token_invalid_code) {
        useShowToast(response.data.msg);
        console.log("登录失效");
        if (utilIsAndroid()) {
          useCallAppHandle("toLogout");
        }
      }
      if ([1237, 567, 3002].includes(response.data.code)) {
        return response.data;
      }
      if ((response.config as any).silent) {
        // 调用方传 silent: true 时自己处理失败、不弹通用提示（如技师宝装修页拉项目列表：未开业技师详情接口回 501）
      } else if (response.data.code === error_code) {
        console.log("code5000");
        useShowToast(response.data.msg);
      } else {
        useShowToast(response.data.msg);
      }
      // 加密解密失败
      if (response.data.code === 523 || response.data.code === 560) {
        console.log("加密解密失败");
        storeData.keyStr = "";
        window.location.reload();
        return;
      }
      return response.data;
    }
  },
  (error: AxiosError) => {
    console.log("err" + error); // for debug
    return Promise.reject(error);
  }
);

export { service };
